module.exports = __webpack_public_path__ + "static/[edgeinnovationcenter.com][887]1-6-5da8e03469e1d2c210800c7b434ef17f.jpg";